import { Lock } from 'lucide-react';
import EmptyState from '@/components/ui/EmptyState';
import { useIsFeatureLocked } from '@/hooks/useFeatureAccess';

interface Props {
  children: React.ReactNode;
  feature: string;
  title: string;
  description: string;
}

// No redirige: pinta. Una redireccion a /upgrade haria imposible explicar en
// la propia pagina que se ha perdido.
export default function FeatureProtectedRoute({ children, feature, title, description }: Props) {
  const locked = useIsFeatureLocked(feature);
  if (locked) {
    return (
      <div className="p-4 sm:p-6 lg:p-8 max-w-3xl mx-auto">
        <EmptyState
          icon={Lock}
          iconTone="amber"
          title={title}
          description={description}
          actionLabel="Ver planes"
          actionHref="/upgrade"
        />
      </div>
    );
  }
  return <>{children}</>;
}
